export const onClickHandler: (onClick: () => void) => (event: React.MouseEvent) => void = onClick => (ev) => {
  ev.stopPropagation();
  ev.preventDefault();
  onClick();
};
